import { lazy } from "react";

export const Home = lazy(() => import("../pages/dashboard/home/index"));
export const Reporting = lazy(() => import("../pages/dashboard/reporting"));
export const Desktop = lazy(() => import("../pages/dashboard/desktop-app"));
export const Solutions = lazy(() => import("../pages/dashboard/solutions"));

export const AutomationServices = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/automation-solutions/automation-services"
    )
);
export const RoboticAutomation = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/automation-solutions/robotic-automation"
    )
);
export const WorkflowAutomation = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/automation-solutions/workflow-automation"
    )
);

export const OutageHub = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/support-and-expertise/outage-hub/"
    )
);
export const Troubleshooting = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/support-and-expertise/troubleshooting"
    )
);

export const ProjectExecution = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/project-and-knowledge/project-execution"
    )
);
export const AgnosticKnowledge = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/project-and-knowledge/agnostic-knowledge"
    )
);
export const Onboarding = lazy(
  () =>
    import(
      "../pages/dashboard/solutions/pages/project-and-knowledge/onboarding"
    )
);

export const Integrations = lazy(
  () => import("../pages/dashboard/integrations")
);
export const Portal = lazy(() => import("../pages/dashboard/portal"));
export const Roadmap = lazy(() => import("../pages/dashboard/roadmap"));
export const Feedback = lazy(() => import("../pages/dashboard/feedback"));
export const Sweepstakes = lazy(() => import("../pages/dashboard/sweepstakes"));
export const Investments = lazy(() => import("../pages/dashboard/investments"));
export const OAuthCallback = lazy(() => import("../pages/auth/oauth-callback"));
